import * as React from 'react';

export const Divider = (props: any) => {
  return <div {...props} />;
};
